import { QueryClient } from '@tanstack/react-query'
import { ApiError } from '@/types'

/**
 * Shared React Query client.
 *
 * Retry policy: retry up to 2 times, but never retry on 4xx errors
 * (bad requests / permission denied should surface immediately).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,          // 30 s — data is fresh for 30 s
      gcTime: 5 * 60_000,         // 5 min — keep unused cache entries for 5 min
      refetchOnWindowFocus: false, // avoid surprise re-fetches on tab switch
      retry: (failureCount, error) => {
        if (error instanceof ApiError && error.code !== 'NETWORK_ERROR') {
          // Don't retry API errors (4xx / 5xx) — only network-level failures
          return false
        }
        return failureCount < 2
      },
    },
    mutations: {
      retry: false,
    },
  },
})
